
import React from 'react';
import { MessageSquare } from 'lucide-react';
import { debugVoteFlow } from '@/utils/debug';

interface CommentHeaderProps {
  commentCount: number;
}

const CommentHeader: React.FC<CommentHeaderProps> = ({ commentCount = 0 }) => {
  const displayCount = typeof commentCount === 'number' ? commentCount : 0;
  
  // Replace console.log with our debug utility
  debugVoteFlow('CommentHeader: Rendering with count', displayCount);
  
  return (
    <div className="flex items-center gap-2">
      <MessageSquare className="h-5 w-5" />
      <h3 className="text-lg font-medium">All Comments ({displayCount})</h3>
    </div>
  );
};

export default CommentHeader;
